import { createAction } from 'typesafe-actions';

export const setPage = createAction('REPOSITORY_PAGE_SET', action => (pageIndex: number) => action(pageIndex));
export const setPageSize = createAction('REPOSITORY_PAGE_SIZE_SET', action => (pageSize: number) => action(pageSize));
